<template>
  <!--修改密码 -->
  <div>
    <div class="center">
      
      <div class="center-nav">
        <el-form>
        <div  style="display: flex; justify-content: center">
          <div style="max-width:480px">
            <div class="center-from">
              <!-- <el-form-item style="margin-bottom:0">
              <div class="center-from-item">
                
                
                  
                    <span>*</span>
                    <p>{{$t('CountryRegion')}}</p>
                    <img
                  class="center-from-item-img"
                  src="../assets/revamp/xguser.png"
                />
                  
                  <el-phone-number-input
                 
                    v-model="formLabelAlign.regionPhone"
                  ></el-phone-number-input>
                  <el-input v-model="formLabelAlign.name"></el-input>
                
               
              </div>
              </el-form-item> -->
              <div class="center-from-item">
                <img
                  class="center-from-item-img"
                  src="../assets/revamp/xguser.png"
                />
                <div class="phone-box center-from-item-div">
                  <country-select style="flex:1;overflow: hidden;" @input="countryInput"></country-select>
                  <span class="line" style="margin-left: 4px;"></span>
                  <el-input
                  style="flex:3.3"
                  v-model="formLabelAlign.phone"
                  :placeholder="$t('Phonenumberbody')"
                  ></el-input>
                </div>
                <!-- <input
                  class="center-from-item-input"
                  type="text"
                  :placeholder="$t('Account')"
                  v-model="formLabelAlign.phone"
                /> -->
              </div>
              
              <div class="center-from-item">
                <img
                  class="center-from-item-img"
                  src="../assets/revamp/xgpassed.png"
                />
                <div class="center-from-item-div">
                  <input
                    class="center-from-item-div-input"
                    type="text"
                    :placeholder="$t('Captcha')"
                    v-model="formLabelAlign.verifyCode"
                  />
                  <el-button
                    class="center-from-item-div-btn"
                    @click.stop="time == -1 ? getCode() : ''"
                    >{{
                      time == -1 ? $t('ObtainCaptcha') : time + $t('secondsleft')
                    }}</el-button
                  >
                </div>
              </div>
              <div class="center-from-items">
                <div>
                  <div class="flex">
                    <img
                      class="center-from-item-img"
                      src="../assets/revamp/xgpassed.png"
                    />
                    <div style="width: 100%">
                      <input
                        class="center-from-item-input"
                        type="password"
                        
                        :placeholder="$t('Password')"
                        v-model="formLabelAlign.password"
                      />
                      <div class="center-from-item-hint">
                        {{$t('digipasswordcassensitive')}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="center-from-item">
                <img
                  class="center-from-item-img"
                  src="../assets/revamp/xgpassed.png"
                />
                <input
                  class="center-from-item-input"
                  type="password"
                  
                  :placeholder="$t('ConfirmPassword')"
                  v-model="formLabelAlign.repassword"
                />
              </div>
            </div>
            <el-button class="center-btn" @click.stop="confirm"
              ><span style="color: white !important">{{$t('Change')}}</span></el-button
            >
          </div>
        </div>
        </el-form>
      </div>
       
    </div>
  </div>
</template>

<script>
  import CountrySelect from "../components/countrySelect.vue";
import {
  ElPhoneNumberInput,
  mobileValidator,
  phoneNumberValidator,
} from "el-phone-number-input";
export default {
  components: {
    ElPhoneNumberInput,
    CountrySelect
  },
  data() {
    return {
      loadingCode: false,
      loadingSub: false,
      timer: null,
      time: -1,
      formLabelAlign: {
        phone: JSON.parse(localStorage.getItem('userInfo2')).phone,
        verifyCode: "",
        regionPhone: {
          callingCode: "86",
          countryCode: "CN",
          phoneNumber: undefined,
        },
        region: "",

        password: "",
        repassword: "",
      },
    };
  },
  beforeDestroy() {
    this.timer = null;
  },
  methods: {
    countryInput(val){
      console.log(val)
      this.formLabelAlign.region = val
    },
    getCode() {
      console.log(this.formLabelAlign.regionPhone);
      // countryCode
      
      if (
        this.formLabelAlign.regionPhone.callingCode === ""||
        this.formLabelAlign.regionPhone === "" ||
        (this.formLabelAlign.regionPhone &&
          this.formLabelAlign.regionPhone.callingCode === undefined)
      ) {
        this.$message({
          message: this.lang=='zh'? "请选择国家/地区":'Please select a country/region',
        });
        return;
      }
      this.formLabelAlign.region = this.formLabelAlign.regionPhone.callingCode;
      if (!this.$test.mobile(this.formLabelAlign.phone)) {
        this.$message({
          message: this.lang=='zh'? "请输入正确的手机号":'Please enter the correct mobile phone number',
        });
        return;
      }

   
      if (this.loadingCode) {
        return;
      }
      this.loadingCode = true;
      this.$postHttp("pc/tJudgesInfo/sendSms", {
        number: +this.formLabelAlign.phone,
        areaCode: this.formLabelAlign.region,
      })
        .then((res) => {
          console.log(res);
          if (res.success) {
            console.log('success');
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.loadingCode = false;
            this.startTimer(60);
            
          } else {
            console.log('error');
            this.$message({
              message: res.msg,
            });
            this.loadingCode = false;
          }
        })
        .catch(() => {
          this.loadingCode = false;
        });
    },
    startTimer(time) {
         console.log(time);
      this.time = time;
      this.timer = setInterval(() => {
        this.time = this.time - 1;
        if (this.time < 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    confirm() {
      // this.SETACTIVE(7)
      // return
      // this.$router.push({ path:'/two.html'  })

      //   console.log(this.formLabelAlign);
      if (
        this.formLabelAlign.regionPhone.callingCode === ""||
        this.formLabelAlign.regionPhone === "" ||
        (this.formLabelAlign.regionPhone &&
          this.formLabelAlign.regionPhone.callingCode === undefined)
      ) {
        this.$message({
          message: this.lang=='zh'? "请选择国家/地区":'Please select a country/region',
        });
        return;
      }
      this.formLabelAlign.region = this.formLabelAlign.regionPhone.callingCode;
      if (!this.$test.mobile(this.formLabelAlign.phone)) {
        this.$message({
          message: this.lang=='zh'? "请输入正确的手机号":'Please enter the correct mobile phone number',
        });
        return;
      }
    //   console.log(
    //     this.formLabelAlign.verifyCode,
    //     "this.formLabelAlign.verifyCode"
    //   );
      if (!this.formLabelAlign.verifyCode != "") {
        this.$message({
          message: this.lang=='zh'?"请输入验证码":'Please enter the verification code',
        });
        return;
      }
      if (this.formLabelAlign.password == "") {
        this.$message({
          message: this.lang=='zh'?"请输入新密码":'Please enter a new password',
        });
        return;
      }
      if (this.formLabelAlign.password.length>16||this.formLabelAlign.password.length < 6) {
        this.$message({
          message: this.lang=='zh'?"密码长度在6位与16位之间":'Password length is between 6 and 16 bits',
        });
        return;
      }
      // 
      if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(this.formLabelAlign.password))) {
        this.$message({
          message: this.lang=='zh'?"密码必须包含数字和字母":'The password must contain numbers and letters',
        });
        return;
      }
      if (this.formLabelAlign.repassword != this.formLabelAlign.password) {
        this.$message({
          message:this.lang=='zh'?"两次密码不一致":'Two passwords are inconsistent',
        });
        return;
      }

      if (this.loadingSub) {
        return;
      }
      this.loadingSub = true;
      this.$postHttp("pc/tJudgesInfo/modify", {
        phone: +this.formLabelAlign.phone,
        password: this.formLabelAlign.password,
        verifyCode: this.formLabelAlign.verifyCode,
        
        region: this.formLabelAlign.region
      })
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.loadingSub = false;
            setTimeout(() => {
              this.SETACTIVE(7);
            }, 2000);
          } else {
            this.$message({
              message: this.lang=='zh'?'验证码输入错误！':'Verification code input error!',
            });
            this.loadingSub = false;
          }
        })
        .catch(() => {
          this.loadingSub = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-input-group__prepend > .el-select {
    margin-left: -55px !important;
}
.el-input-group__prepend {
  padding-left: 4px !important;
  .el-input__inner {
    color: #333333 !important;
    &::placeholder {
      color: #999 !important;
    }
  }
}
.el-input__suffix {
  right: -12px !important;
}



.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.center .country-select .el-input__suffix{
  bottom: 7px !important;
}
.center {
  // background-image: url(../assets/revamp/xgback.png);
  // background-repeat: no-repeat;
  // background-position: 0 100%;
  .center-nav {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    text-align: center;
    padding-bottom: 85px;
    display: flex;
    justify-content: center;
    .center-title {
      font-size: 26px;
      font-weight: 500;
      color: #333333;
      text-align: left;
      display: flex;
      align-items: center;
      margin-bottom: 40px;
    }
    .center-title::before {
      content: "";
      display: inline-block;
      width: 4px;
      height: 24px;
      background: #6f73f4;
      border-radius: 2px;
      margin-right: 18px;
    }
    .center-from {
      .center-from-item {
        display: flex;
        align-items: center;
        // justify-content: center;
        margin-bottom: 31px;
        .country-select{
            margin-top: -2px;
          .el-input__suffix{
            right: 1px !important;
            bottom: 7px !important;
          }
        }
        .center-from-item-img {
          width: 33px;
          height: 33px;
          margin-right: 21px;
        }
        .center-from-item-input {
          // width: 400px;
          // height: 50px;
          width: 100%;
          height: 50px;
          border-radius: 6px;
          border: 1px solid #d0d0d0;
          padding-left: 21px;
          font-size: 14px;
        }
        .center-from-item-input::placeholder {
          color: #999;
          font-size: 14px;
        }
        .center-from-item-div {
          // width: 400px;
          width: 100%;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .center-from-item-div-input {
            width: 220px;
            height: 50px;
            border-radius: 6px;
            border: 1px solid #d0d0d0;
            padding-left: 21px;
            font-size: 14px;
          }
          .center-from-item-div-input::placeholder {
            color: #999;
            font-size: 14px;
          }
          .center-from-item-div-btn {
            width: 167px;
            height: 50px;
            border-radius: 6px;
            border: 1px solid #6f73f4;
            font-size: 14px;
            color: #6f73f4;
          }
        }
      }
      .center-from-items {
        margin-bottom: 14px;
        .center-from-item-img {
          width: 33px;
          height: 33px;
          margin-right: 21px;
        }
        .center-from-item-input {
          width: 100%;
          height: 50px;
          border-radius: 6px;
          border: 1px solid #d0d0d0;
          padding-left: 21px;
          font-size: 14px;
        }
        .center-from-item-input::placeholder {
          color: #999;
          font-size: 14px;
        }
        .center-from-item-hint {
          // width: 454px;
          height: 17px;
          margin: 0 auto;
          text-align: right;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
        }
      }
    }
    .center-btn {
      width: 220px;
      height: 56px;
      background: linear-gradient(262deg, #6a9cff 0%, #5257ff 100%);
      border-radius: 10px;
      font-size: 24px;
      font-weight: 600;
      color: #fff;
      margin-top: 41px;
    }
  }
}
@media screen and (max-width: 414px) {
  .center-from-item-img {
    margin-right: 5px !important;
  }

  .center-from-item-div-btn {
    width: 100% !important;
  }

  .center-from-item-div-input{
    width: 100% !important;
  }
}


</style>
